class VpMegamenuNav extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLElement[]} */
    this.links = [];
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.links = [...this.querySelectorAll(".vp-header-menus__item-with-dropdown")].filter(
      (el) => el instanceof HTMLElement
    );
    this.links.forEach((link) => {
      const trigger = link.querySelector(".vp-header-menus__item-link");
      if (!trigger) return;

      trigger.addEventListener("click", /** @param {MouseEvent} event */ (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleClick(link);
      });
    });
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
  }

  /** @param {MouseEvent} event */
  onDocumentClick(event) {
    if (!(event.target instanceof Node)) return;
    if (this.contains(event.target)) return;
    this.closeAll();
  }

  /** @param {KeyboardEvent} event */
  onKeydown(event) {
    if (event.key !== "Escape") return;
    if (!this.querySelector(".vp-header-menus__item-dropdown-open")) return;
    event.preventDefault();
    this.closeAll();
  }

  closeAll() {
    this.links.forEach((link) => {
      link.querySelector(".vp-header-menus__item-dropdown")?.classList.remove("vp-header-menus__item-dropdown-open");
    });
  }

  /** @param {HTMLElement} link */
  handleClick(link) {
    const dropdown = link.querySelector(".vp-header-menus__item-dropdown");
    if (!dropdown) return;

    const wasOpen = dropdown.classList.contains("vp-header-menus__item-dropdown-open");

    this.links.forEach((otherLink) => {
      if (otherLink === link) return;
      otherLink
        .querySelector(".vp-header-menus__item-dropdown")
        ?.classList.remove("vp-header-menus__item-dropdown-open");
    });

    if (wasOpen) {
      dropdown.classList.remove("vp-header-menus__item-dropdown-open");
    } else {
      dropdown.classList.add("vp-header-menus__item-dropdown-open");
    }
  }
}

if (!customElements.get("vp-megamenu-nav")) {
  customElements.define("vp-megamenu-nav", VpMegamenuNav);
}
